import React, { useEffect } from 'react';
import PageKit from '../PageKit';
import TitleBanner from '../component/TitleBanner.js';
import ContactForm from '../component/ContactForm';
import { useTranslation } from "react-i18next";

function Contact() {
    const { t } = useTranslation();

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'auto' });
    }, []);

    return (
        <PageKit>
            <>
                <TitleBanner
                    imageSrc={`${process.env.PUBLIC_URL}/img/Banners/geometricbanner8.png`}
                    title={t("Navbar.Contact")}
                    height="150px"
                />
                <ContactForm />
            </>
        </PageKit>
    );
}

export default Contact;
